import { defineStore } from 'pinia'

import { user } from '../api/auth'
import { setAuthState } from '../composables/auth'

import { getPrices } from '../api/purchase'

const stripeKey = process.env.MIX_STRIPE_KEY

export const useTokens = defineStore('token-store', {
  state: () => ({
    stripeKey,

    tokens: null,
    options: [],
    selectedOption: null,
  }),
  actions: {
     initTokens() {
      const { isAuthenticated, getUser } = setAuthState()

      if (!isAuthenticated()) {
        return
      }

     const user =  getUser()
     const tokens = [user?.generations]
        .reduce((acc, curr) => acc + (curr || 0), 0)
     this.tokens = tokens
    },

    async refresh() {
      const { setUser } = setAuthState()
      const result = await user()

        if (result?.data?.data) {
        setUser(result.data?.data)
        const { generations } = result.data.data

        const tokens = [generations]
          .reduce((acc, curr) => acc + (curr || 0), 0)
        this.tokens = tokens
      }
    },

    async initOptions() {
      const result = await getPrices()
      this.options = (result || [])
        .sort((a, b) => a.unit_amount - b.unit_amount)
        .map((e) => ({
          id: e.id,
          product: e.product,
          title: e.metadata.title,
          amount: e.metadata.amount,
          description: e.metadata.description,
          points: e.metadata.points,
          best: e.metadata.best === 'true',
          cost: e.unit_amount / 100,
        }))
    },

    selectOption(plan) {
      this.selectedOption = plan ? { ...plan } : null
    }
  },
  getters: {
    hasLowTokens() {
      return this.tokens < 5 && this.tokens > 0
    },
    hasNoTokens() {
      return this.tokens <= 0
    },
  }
})
